import { useEffect } from "react";
import { useReportRepository } from "../../../api/repositories/ReportRepository";
import { IChipLoadingProps } from "../../../constants/FinanceModels";
import { ID_IMPORTED, ID_LOADING, ID_PROCESSED, ID_SENT } from "../constants/EnelxStatuses";
import ColouredChip from "../../../component/ColouredChip";
import { COLOR_IMPORTED, COLOR_PROCESSED, COLOR_SENT } from "../constants/EnelxColors";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function ChipDynamic(props: IChipLoadingProps) {

    const { getReportById } = useReportRepository();

    const controller = new AbortController();
    const { t } = useTranslation('finance');

    function showChip() {
        switch (props.initialValue) {
            case ID_PROCESSED:
                return (<ColouredChip name={ID_PROCESSED} color={COLOR_PROCESSED}/>)
            case ID_IMPORTED:
                return (<ColouredChip name={ID_IMPORTED} color={COLOR_IMPORTED}/>)
            case ID_SENT:
                return (<ColouredChip name={ID_SENT} color={COLOR_SENT}/>)
            default:
                return (<Stack display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{ height: '35px' }} direction={'row'} spacing={1}>
                            <Typography fontSize={'small'}>
                                {t(`chips.${ID_LOADING}`)}
                            </Typography>
                            <CircularProgress size={15} disableShrink={true}/>
                        </Stack>
                )
        }
    }

    function updateData() {
        getReportById(props.id, { signal: controller.signal })
                .then(response => {
                    if (response.result.status !== props.initialValue) {
                        props.data.status = response.result.status;
                        props.data.rowCount = response.result.rowCount;
                        props.redrawRows();
                    } else {
                        setTimeout(() => updateData(), props.interval);
                    }
                })
                .catch(() => {
                    if (!controller.signal.aborted) {
                        setTimeout(() => updateData(), props.interval);
                    }
                });
    }

    useEffect(() => {
        if (props.initialValue === ID_LOADING) {
            updateData();
        }
        return () => {
            controller.abort();
        }
    }, [])


    return (
            <>
                {showChip()}
            </>
    );
}

export default ChipDynamic;